import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './Footer.css'
import FooterLogo from './footerLogo/FooterLogo'
import { Link } from 'react-router-dom'

/**
 * Footer - Global Component
 *
 * @author Mike Rudling <mrudling@wearearchitect.com>
 */
export default class Footer extends Component {
  /**
   * Default Props
   *
   * @type {{footerList: *[], footerLogo: {url: string, text: string, alt: string}, footerNotes: string[], orderedList: boolean, shareVisible: boolean}}
   */
  static defaultProps = {
    footerList: [
      {
        text: 'Our Products',
        url: '/our-products'
      },
      {
        text: 'Where to Buy',
        url: '/where-to-buy'
      },
      {
        text: 'Contact',
        url: '/contact'
      }
    ],
    footerLogo: {
      url: '/',
      text: '',
      alt: 'Footer Logo'
    },
    secondaryFooterList: [
      {
        text: 'Privacy Policy',
        url: '/'
      },
      {
        text: 'Terms & Conditions',
        url: '/'
      },
      {
        text: '© 2018 Solero®. All Rights Reserved.'
      }
    ],
    orderedList: false,
    shareVisible: true
  }

  /**
   * Prop types
   *
   * @type {{footerList: *, footerLogo: shim, footerNotes: shim, orderedList: shim, shareVisible: shim}}
   */
  static propTypes = {
    footerList: PropTypes.array.isRequired,
    secondaryFooterList: PropTypes.array.isRequired,
    footerLogo: PropTypes.object,
    footerNotes: PropTypes.array,
    orderedList: PropTypes.bool,
    orderedListSecondary: PropTypes.bool,
    shareVisible: PropTypes.bool
  }

  /**
   * Render
   *
   * @returns {XML}
   */
  render() {
    const { footerList, footerLogo, secondaryFooterList, orderedList } = this.props

    let footerItems = footerList.map(function(footerItem, index) {
      return (
        <li key={index}>
          <Link to={footerItem.url}>{footerItem.text}</Link>
        </li>
      )
    }, this)

    secondaryFooterList.map(function(secondaryFooterItem, index) {
      return (
        <li key={index}>
          <a href={secondaryFooterItem.url} target="_blank">
            {secondaryFooterItem.text}
          </a>
        </li>
      )
    }, this)

    return (
      <footer className="Footer">
        <div>
          <div className="Footer-logo">
            <FooterLogo url={footerLogo.url} text={footerLogo.text} alt={footerLogo.alt} />
          </div>

          {orderedList ? <ol>{footerItems}</ol> : <ul>{footerItems}</ul>}
        </div>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global/footer/Footer.jsx